<template>
  <div class="page-container">
    <div class="page-header">
      <div class="header-left">
        <div class="header-logo" @click="ebookList">
          <img src="@/assets/images/common/default_logo.png">
        </div>
        <div class="header-title">
          <h3 :title="basicData.title">
            《{{ basicData.title }}》
          </h3>
        </div>
      </div>
      <div class="header-action">
        <div class="action-mind-map" @click="mindMapShowHanle">
          <img src="@/assets/images/common/mind-map.png">
          脑图
        </div>
      </div>
    </div>
    <div class="page-content">
      <sideBar :showLogo="false">
        <template slot="actions">
          <div>
            <div
              class="actions-btn actions-catalog-btn"
              :class="actionShow && actionType === 'catalog' ? 'actions-btn-active' : ''"
              @click="actionShowHandle('catalog')"
              title="目录"
            >
              <span class="actions-btn-icon"></span>
            </div>
            <div
              class="actions-btn actions-setting-btn"
              :class="actionShow && actionType === 'setting' ? 'actions-btn-active' : ''"
              @click="actionShowHandle('setting')"
              title="设置"
            >
              <span class="actions-btn-icon"></span>
            </div>
          </div>
        </template>
      </sideBar>
      <div class="main">
        <!-- <myHeader></myHeader> -->
        <div class="action-left" :class="actionShow ? '' : 'hideAction'" :style="{'--sidebar-left-width': sidebarLeftWidth + 'px',}">
          <div class="action-left-block">
            <div class="catalog" v-show="actionType == 'catalog'">
              <div class="book-info">
                <div class="book-pic-box">
                  <img :src="basicData.cover">
                </div>
                <div class="book-txt">
                  <h3 class="ellipsis-2" :title="basicData.title">
                    {{ basicData.title }}
                  </h3>
                  <p v-if="basicData.judge">{{ basicData.judge }}</p>
                  <p>{{ basicData.editor }}</p>
                </div>
              </div>
              <!-- <div class="read-percent">
                <div class="read-percent-left">阅读进度：</div>
                <el-progress class="read-percent-right" :percentage="readPercentage"></el-progress>
              </div> -->
              <div class="catalog-title">目录</div>
              <NavBar class="catalog-list" ref="navBar" :content="navBarData" @chapterChange="chapterChange"></NavBar>
            </div>
            <div class="setting" v-show="actionType == 'setting'">
              <setting @fontSizeChange="fontSizeChange" @backgroundColorChange="backgroundColorChange"></setting>
            </div>
          </div>
          
          <!-- 拖拽元素 start -->
          <div class="drag-action" @mousedown="startResizeLeft"></div>
          <!-- 拖拽元素 end -->
        </div>
        <div class="read-main">
          <!-- <div class="header">
            <h3>项目一 搭建机器学习开发环境</h3>
          </div> -->
          
          <!-- 书本内容展示区 start -->
          <div
            class="read-main-mid"
            :style="{
              'transform': `scale(${resizeScale})`,
              'paddingBottom': `${ resizeScale > 1 ? (resizeScale * (contentHeight -6) - contentHeight) / resizeScale : 0 }px`
            }"
          >
            <div class="bg-logo"><img src="@/assets/images/common/right-bottom-logo.png" /></div>
            <div
              class="read-content"
              id="read-content"
              ref="content"
              @scroll="handleScrollDB"
            >
              <bookContent ref="bookContent" :bookContent="bookContentData" @checkSelection="checkSelection">
                <template v-slot:bubble>
                  <!-- 内容操作弹出层 start -->
                  <div
                    ref="bubble"
                    class="bubble"
                    v-if="isBubbleVisible"
                    :style="{ top: bubbleTop + 'px', left: bubbleLeft + 'px' }"
                  >
                    <a @click="markSelection('highlight')">标记</a
                    ><a @click="markSelection('note')">笔记</a
                    ><a @click="copyTxt">复制</a
                    ><a @click="fillError">纠错</a
                    ><a @click="toDictionary">字典</a
                    ><a @click="toBaike">百科</a>
                  </div>
                  <!-- 内容操作弹出层 end -->
                </template>
              </bookContent>
            </div>
            <!-- 定位回跳位置 start -->
            <div class="position-fixed" v-if="showHistoryPosition" @click="toHistoryPosition">返回</div>
            <!-- 定位回跳位置 end -->
          </div>
          <!-- 书本内容展示区 end -->
        </div>
        
        <div class="action-right" :class="actionRightShow ? '' : 'hideActionRight'" :style="{'--sidebar-right-width': sidebarRightWidth + 'px',}">
          <div class="action-right-block">
            <!-- 右侧标记列表 start -->
            <div class="setting-right highlight" v-show="actionRightType == 'highlight'">
              <div class="action-right-title">标记</div>
              <div v-show="!highlightList.length" class="blank-box">暂无数据</div>
              <highlight
                class="action-right-inner"
                :highlightList="highlightList"
                v-show="highlightList.length"
                @delRecordLi="delRecordLi"
                @mindMapAdd="mindMapAdd"
                @chapterChange="chapterChange"
                @tableTabChange="tableTabChange"
              ></highlight>
            </div>
            <!-- 右侧标记列表 end -->
            <!-- 右侧笔记列表 start -->
            <div class="setting-right note" v-show="actionRightType == 'note'">
              <div class="action-right-title">笔记</div>
              <div v-show="!noteList.length" class="blank-box">暂无数据</div>
              <noteList
                class="action-right-inner"
                :noteList="noteList"
                :activeNote="activeNote"
                v-show="noteList.length"
                @delRecordLi="delRecordLi"
                @mindMapAdd="mindMapAdd"
                @editNote="editNote"
                @chapterChange="chapterChange"
                @tableTabChange="tableTabChange"
              ></noteList>
            </div>
            <!-- 右侧笔记列表 end -->
            <!-- 右侧资源列表 start -->
            <div class="setting-right" v-show="actionRightType == 'files'">
              <div class="action-right-title">资源下载</div>
              <div v-show="!fileDownloadList.length" class="blank-box">暂无数据</div>
              <fileDownload class="action-right-inner" v-show="fileDownloadList.length" :fileList="fileDownloadList"></fileDownload>
            </div>
            <!-- 右侧资源列表 end -->
            <!-- 右侧搜索列表 start -->
            <div class="setting-right" v-show="actionRightType == 'search'">
              <div class="action-right-title">搜索</div>
              <search class="action-right-inner" :bookContent="bookContentDataAll" :activeChapter="activeChapter" @chapterChange="chapterChange" @tableTabChange="tableTabChange"></search>
            </div>
            <!-- 右侧搜索列表 end -->
          </div>
           
          <!-- 拖拽元素 start -->
          <div class="drag-action" @mousedown="startResizeRight"></div>
          <!-- 拖拽元素 end -->
        </div>
      </div>
      <div class="side-bar-right">
        <div
          class="actions-btn actions-highlight-btn"
          :class="actionRightShow && actionRightType === 'highlight' ? 'actions-btn-active' : ''"
          @click="actionRightShowHandle('highlight')"
          title="高亮"
        >
          <span class="actions-btn-icon"></span>
          <span class="action-name">标记</span>
        </div>
        <div
          class="actions-btn actions-note-btn"
          :class="actionRightShow && actionRightType === 'note' ? 'actions-btn-active' : ''"
          @click="actionRightShowHandle('note')"
          title="笔记"
        >
          <span class="actions-btn-icon"></span>
          <span class="action-name">笔记</span>
        </div>
        <!-- <div class="actions-btn" @click="actionRightShowHandle('mark')">标记</div> -->
        <div
          class="actions-btn actions-search-btn"
          :class="actionRightShow && actionRightType === 'search' ? 'actions-btn-active' : ''"
          @click="actionRightShowHandle('search')"
          title="搜索"
        >
          <span class="actions-btn-icon"></span>
          <span class="action-name">搜索</span>
        </div>
        <div
          class="actions-btn actions-files-btn"
          :class="actionRightShow && actionRightType === 'files' ? 'actions-btn-active' : ''"
          @click="actionRightShowHandle('files')"
          title="文件"
        >
          <span class="actions-btn-icon"></span>
          <span class="action-name">资源</span>
        </div>
      </div>
    </div>
    <noteDrawer
      :randomValue="randomValue"
      :drawerNoteVisible="drawerNoteVisible"
      :selectedText="selectedText"
      :noteTextareaContent="noteTextareaContent"
      :noteDrawerType="noteDrawerType"
      @changeNoteTextarea="changeNoteTextarea"
      @submitNote="submitNote"
      @cancelSubmitNote="cancelSubmitNote"
    ></noteDrawer>
    <fillErrorDrawer
      :drawerFillError="drawerFillError"
      @cancelFillError="cancelFillError"
    ></fillErrorDrawer>
    <mindMap
      ref="mindMap"
      :mindMapVisible="mindMapVisible"
      :mindMapData="mindMapData"
      @closeDiaLog="mindMapHideHanle"
      @deleteMind="deleteMind"
      @mindMapUpdate="mindMapUpdate"
    ></mindMap>
  </div>
</template>
<script>
// import book1 from "./book-1"
// import bookExample from "./book-example"
// 示例图书
import bookExample from "../../books/book-example/index"
// 图书1--机械制图与AutoCAD
import book1 from "../../books/book-1/index"
// 图书2--英语教材
import book2 from "../../books/book-2/index"
import sideBar from '@/layout/sideBar.vue'
import myHeader from '@/layout/header'
import NavBar from './components/sideBarLeft/navBar.vue'
import bookContent from './components/bookContent.vue'
import setting from './components/sideBarLeft/setting.vue'
import highlight from './components/sideBarRight/highlight.vue'
import noteList from './components/sideBarRight/noteList.vue'
import noteDrawer from './components/sideBarRight/noteDrawer.vue'
import fillErrorDrawer from './components/fillErrorDrawer.vue'
import fileDownload from './components/sideBarRight/fileDownload.vue'
import search from './components/sideBarRight/search.vue'
import mindMap from './components/mindMap.vue'
import { getMarkList, setMarkList, getMindMap, setMindMap, getReadPercent, setReadPercent, getHistoryPosition, setHistoryPosition } from "@/utils/storage";
import { debounce } from 'lodash'
import axios from 'axios'
// import CircularJSON from 'circular-json'
// const stringify = require('json-stringify-safe')

const fs = require('fs');

export default {
  data() {
    return {
      basicData: {}, // 书籍的基本信息
      navBarData: [], // 书籍的目录信息
      bookContentDataAll: {}, // 全部书籍内容
      bookContentData: [],  // 当前章节的书籍内容
      activeChapter: '',
      activeChapterKey: '',
      actionShow: true,
      actionType: 'catalog',
      actionRightShow: true,
      actionRightType: 'highlight',
      sidebarLeftWidth: 400,
      sidebarRightWidth: 400,
      isResizing: false,
      resizeStartX: 0,
      resizeOriginX: 0,
      isBubbleVisible: false,
      bubbleTop: '',
      bubbleLeft: '',
      randomValue: '',
      markList: [],
      // highlightList: [],
      activeMark: '',
      // noteList: [],
      activeNote: '',
      drawerNoteVisible: false,
      selectedText: '',
      noteTextareaContent: '',
      noteDrawerType: 'add',
      noteAddParam: {},
      drawerFillError: false,
      searchResultList: [], // 搜索结果列表
      mindMapVisible: false,
      mindMapData: {}, // 脑图数据
      fileDownloadList: [], // 文件下载列表
      readPercentData: {}, //全部已阅读的百分比数据
      readPercentage: 0, //当前页已阅读的百分比
      fontSizeChangeVal: 50, // 记录字体大小变化
      showHistoryPosition: false, // 是否展示定位回跳
      resizeScale: 1,
      contentHeight: 0,
    }
  },
  provide() {
    return {
      saveHistoryPosition: this.saveHistoryPosition,
      chapterChange: this.chapterChange,
      findChapterFrom: this.findChapterFrom,
    }
  },
  components: {
    sideBar,
    myHeader,
    NavBar,
    bookContent,
    setting,
    highlight,
    noteList,
    noteDrawer,
    fillErrorDrawer,
    fileDownload,
    search,
    mindMap,
  },
  computed: {
    highlightList() {
      return this.markList.filter(item => item.type === 'highlight' && item.activeChapterKey === this.activeChapterKey)
    },
    noteList() {
      return this.markList.filter(item => item.type === 'note' && item.activeChapterKey === this.activeChapterKey)
    },
  },
  mounted() {
    // this.bookContentData = book1;
    let bookDetail = {}
    if(this.$route.query.book_id == 1) {
      this.activeChapter = 'introduction';
      bookDetail = book1
    }else if(this.$route.query.book_id == 2) {
      bookDetail = book2
      this.activeChapter = 'chapter1sub1';
    }else{
      bookDetail = bookExample
      this.activeChapter = 'introduction';
    }
    this.readMarkFile();
    
    this.basicData = bookDetail.basic;
    this.navBarData = bookDetail.catalogue;
    document.title = this.basicData.title;
    if(getReadPercent()) {
      this.readPercentData = JSON.parse(getReadPercent())
      this.activeChapter = this.readPercentData.activeChapter
      this.$refs.navBar.changeActiveIndex(this.activeChapter)
    }else{
      this.loadReadPercent();
      this.$refs.navBar.changeActiveIndex(this.activeChapter)
    }
    if((this.activeChapter + '').indexOf('sub') >= 0) {
      this.activeChapterKey = this.activeChapter.split('sub')[0];
    }else{
      this.activeChapterKey = this.activeChapter;
    }
    this.bookContentDataAll = bookDetail.content;
    
    if((this.activeChapter + '').indexOf('sub') >= 0) {
      this.bookContentData = [];
      let activeChapterData = this.navBarData.find(item => item.key == this.activeChapterKey);
      activeChapterData.children.forEach(item => {
        this.bookContentData = this.bookContentData.concat(this.bookContentDataAll[item.key]);
      })
    }else{
      this.bookContentData = bookDetail.content[this.activeChapterKey];
    }
    this.$nextTick(() => {
      this.fontSizeChange(this.fontSizeChangeVal);
      if(this.readPercentData.nowPercent > 0) {
        this.scrollToPercent(this.readPercentData.nowPercent);
      }
    })
    window.openNoteList = this.openNoteList;

    this.fileDownloadList = bookDetail.fileDownload

    let mindMapData = getMindMap()
    if(mindMapData) {
      this.mindMapData = JSON.parse(getMindMap())
    }else{
      this.mindMapData = {
        "data": {
          "isRoot": 1,
          "text": this.basicData.title,
          // "note": "备注",
          // "tag": ["标签"]
        },
        "children": []
      }
    }
    this.$nextTick(() => {
      this.loadMarks();
    })
    document.addEventListener('copy', this.copyPrevent);
    
    let element = document.getElementById('read-content');
    this.contentHeight = element.getBoundingClientRect().height;
    document.addEventListener('wheel', (event) => {
      const scaleStep = 0.1; // 缩放步长，可以根据需要调整

      if (event.ctrlKey) { // 如果按下了Ctrl键
        event.preventDefault(); // 阻止默认的滚动行为
        if (event.deltaY < 0) { // 向上滚动（放大）
          this.resizeScale += scaleStep; // 增加缩放比例
        } else { // 向下滚动（缩小）
          this.resizeScale -= scaleStep; // 减少缩放比例，但要确保不小于1（即不小于原始大小）
          this.resizeScale = Math.max(1, this.resizeScale); // 保证最小缩放比例为1
        }
      }
    }, { passive: false }); // passive选项设为false以允许默认的滚动行为，但在这里我们阻止了它，所以设置为false是安全的
    
    document.addEventListener('click', this.pageDataClick);
  },
  beforeDestroy() {
    document.removeEventListener('copy', this.copyPrevent);
    document.removeEventListener('click', this.pageDataClick);
  },
  methods: {
    // 左侧菜单宽度调整
    startResizeLeft(event) {
      this.isResizing = true;
      this.resizeStartX = event.clientX; // 记录鼠标按下时的位置
      this.resizeOriginX = this.sidebarLeftWidth; // 记录原始宽度
      document.addEventListener('mousemove', this.doResizeLeft); // 添加鼠标移动事件监听器
      document.addEventListener('mouseup', this.stopResizeLeft); // 添加鼠
    },
    // 左侧菜单宽度调整
    doResizeLeft(event) {
      if (this.isResizing) {
        const diffX = event.clientX - this.resizeStartX; // 计算拖拽的距离
        if(this.resizeOriginX + diffX > 400) {
          this.sidebarLeftWidth = 400; // 更新宽度
        }else if(this.resizeOriginX + diffX < 100) {
          this.sidebarLeftWidth = 100; // 更新宽度
        }else{
          this.sidebarLeftWidth = this.resizeOriginX + diffX; // 更新宽度
        }
      }
    },
    // 左侧菜单宽度调整
    stopResizeLeft() {
      if (this.isResizing) {
        this.isResizing = false; // 停止调整大小
        document.removeEventListener('mousemove', this.doResizeLeft); // 移除事件监听器
        document.removeEventListener('mouseup', this.stopResizeLeft); // 移除事件监听器
      }
    },
    // 右侧菜单宽度调整
    startResizeRight() {
      this.isResizing = true;
      this.resizeStartX = event.clientX; // 记录鼠标按下时的位置
      this.resizeOriginX = this.sidebarRightWidth; // 记录原始宽度
      document.addEventListener('mousemove', this.doResizeRight); // 添加鼠标移动事件监听器
      document.addEventListener('mouseup', this.stopResizeRight); // 添加鼠
    },
    // 右侧菜单宽度调整
    doResizeRight(event) {
      if (this.isResizing) {
        // const diffX = event.clientX - this.resizeStartX; // 计算拖拽的距离
        const diffX = this.resizeStartX - event.clientX; // 计算拖拽的距离
        if(this.resizeOriginX + diffX > 400) {
          this.sidebarRightWidth = 400; // 更新宽度
        }else if(this.resizeOriginX + diffX < 100) {
          this.sidebarRightWidth = 100; // 更新宽度
        }else{
          this.sidebarRightWidth = this.resizeOriginX + diffX; // 更新宽度
        }
      }
    },
    // 右侧菜单宽度调整
    stopResizeRight() {
      if (this.isResizing) {
        this.isResizing = false; // 停止调整大小
        document.removeEventListener('mousemove', this.doResizeRight); // 移除事件监听器
        document.removeEventListener('mouseup', this.stopResizeRight); // 移除事件监听器
      }
    },
    ebookList(){
      // window.location.href='https://sae.bjjqe.net/ebookList'
      // 暂不跳转 2025.10.09 修改
      // window.location.href='https://www.wenjingketang.com/ebookList'
    },
    // 页面内容的点击事件
    pageDataClick(e) {
      this.findChapterFrom(e)
    },
    findChapterFrom(e) {
      if((this.activeChapter + '').indexOf('sub') >= 0) {
        let node = e.target ? e.target : e
        
        let element = null
        if(node.id == 'content') {
          element = this.getCloseChild(e)
        }else if(node.parentNode && (node.parentNode.id == "content") && ((((node.parentNode || {}).parentNode || {}).parentNode || {}).id == "read-content")) {
          element = node
        }else{
          element = this.findParentEl(node)
        }
        if(element) {
          let chapterData = this.navBarData.find(item => item.key == this.activeChapterKey).children;
          let activeChapterData = chapterData.find(item => item.firstChildKey === element.id)
          if(activeChapterData){
            this.chapterChange(activeChapterData.key, true)
          }else{
            if(element.previousElementSibling) {
              this.findChapterFrom(element.previousElementSibling, chapterData)
            }
          }
        }
      }
    },
    // 寻找到content下的元素
    findParentEl(node) {
      if(!node) return false;
      if(!node.parentNode) return false;

      if ((node.parentNode.id == "content") && ((((node.parentNode || {}).parentNode || {}).parentNode || {}).id == "read-content")) {
        return node;
      }else{
        if(node.parentNode.id == 'app') {
          return false;
        }
        return this.findParentEl(node.parentNode)
      }
    },
    // 点击到空白区域选择最近的内容
    getCloseChild(e) {
      let nodes = e.target.children || [];
      let element = document.getElementById('read-content');
      let clientY = element.scrollTop + e.clientY - 70;
      let node = null

      for(let i = 0; i< nodes.length; i++) {
        if(nodes[i].offsetTop > clientY) {
          node = nodes[i-1]
          break;
        }
      }
      return node
    },
    // 切换章节
    async chapterChange(index, noPosition, callback) {
      this.isBubbleVisible = false;
      if(this.activeChapter === index) {
        if(callback) {
          callback();
        }
        return;
      }

      if((index + '').indexOf('sub') >= 0) {
        if(!!this.activeChapterKey && this.activeChapterKey == index.split('sub')[0]) {
          this.activeChapter = index;
          let activeChapterData = this.navBarData.find(item => item.key == this.activeChapterKey);
          let firstId = activeChapterData.children.find(item => item.key == this.activeChapter).firstChildKey;
          this.$refs.navBar.changeActiveIndex(index)
          if(noPosition) {
            if(callback) {
              callback();
            }
            return false;
          }
          this.scrollToElement(firstId)
          if(callback) {
            callback();
          }
          return false;
        }else{
          this.activeChapter = index;
          this.activeChapterKey = this.activeChapter.split('sub')[0];
          this.bookContentData = [];
          let activeChapterData = this.navBarData.find(item => item.key == this.activeChapterKey);
          activeChapterData.children.forEach(item => {
            this.bookContentData = this.bookContentData.concat(this.bookContentDataAll[item.key]);
          })
        }
        // this.bookContentData = this.bookContentDataAll[this.activeChapterKey];
      }else{
        this.activeChapter = index;
        this.activeChapterKey = this.activeChapter;
        this.bookContentData = this.bookContentDataAll[this.activeChapterKey];
      }
      this.$refs.navBar.changeActiveIndex(index)
      await this.loadMarks();
      this.$nextTick(() => {
        this.fontSizeChange(this.fontSizeChangeVal);
      })

      if(callback) {
        callback();
      }
      // 是否定位到历史记录的位置
      if(noPosition) return false;

      let percent = 0
      this.readPercentData.children.forEach(chapter => {
        if(chapter.key === index) {
          percent = chapter.percent
        }
        if(chapter.children && chapter.children.length > 0){
          chapter.children.forEach(subchapter => {
            if(subchapter.key === index) {
              percent = subchapter.percent
            }
          })
        }
      })
      this.scrollToPercent(percent);
    },
    saveHistoryPosition() {
      
      let element = document.getElementById('read-content');
      const scrollTop = element.scrollTop;
      let historyPosition = {
        activeChapter: this.activeChapter,
        position: scrollTop
      }
      setHistoryPosition(JSON.stringify(historyPosition))
      this.showHistoryPosition = true
    },
    toHistoryPosition() {
      let historyPosition = JSON.parse(getHistoryPosition())

      this.chapterChange(historyPosition.activeChapter)
      this.scrollToPosition(historyPosition.position)
      this.showHistoryPosition = false
    },
    // 左侧菜单栏的展示、隐藏
    actionShowHandle(type) {
      if(type == this.actionType && this.actionShow) {
        this.actionShow = !this.actionShow
      }else{
        this.actionShow = true
        this.actionType = type
      }
    },
    // 右侧菜单栏的展示、隐藏
    actionRightShowHandle(type) {
      if(type == this.actionRightType && this.actionRightShow) {
        this.actionRightShow = !this.actionRightShow
      }else{
        this.actionRightShow = true
        this.actionRightType = type
      }
    },
    // 脑图弹窗的展示
    mindMapShowHanle() {
      this.mindMapVisible = true
    },
    // 脑图弹窗的隐藏
    mindMapHideHanle() {
      this.mindMapVisible = false
    },
    // 标记列表中的 脑图增加、删除内容
    mindMapAdd(item) {
      // 删除脑图数据，目前只能添加，删除在脑图中删除，添加会持续添加内容
      // if(item.isMindMap) {
      //   // 列表中 isMindMap = 1 代表脑图中存在，删除脑图数据并修改 isMindMap 为0
      //   let mindMap = this.mindMapDelete(this.mindMapData, item.id);
      //   this.mindMapData = mindMap
      //   setMindMap(JSON.stringify(this.mindMapData))
      //   let markIndex = this.markList.findIndex(opt => opt.id === item.id)
      //   this.$set(this.markList[markIndex], 'isMindMap', 0)
      //   setMarkList(JSON.stringify(this.markList))
      //   return false
      // }
      let { chapter: chapterId, subchapter: subchapterId } = this.findChapter(item); // 查找该数据在哪个章节下
      let chapter, subchapter = {}
      this.navBarData.forEach(data => {
        if(data.key === chapterId) {
          chapter = data
        }
        if(subchapterId && data.children && data.children.length > 0) {
          data.children.forEach(child => {
            if(child.key === subchapterId) {
              subchapter = child
            }
          })
        }
      })

      let chapterMindMap = this.mindMapData.children.find(historyItem => historyItem.data.id === chapterId)
      let chapterMindMapIndex = this.mindMapData.children.findIndex(historyItem => historyItem.data.id === chapterId)
      if(chapterMindMap) {
        
      }else{
        // 如果脑图中没有当前所属的章的子项，增加新的章
        chapterMindMap = {
          "id": chapter.key,
          "text": chapter.name,
        }
        // if(item.note) {
        //   newChapterData.type = "note"
        //   newChapterData.note = item.note
        // }
        this.mindMapData.children.push({
          "data": chapterMindMap,
          "children": [],
        })
        chapterMindMapIndex = this.mindMapData.children.length - 1
      }
      if(subchapterId) {
        // 如果新增的数据是在节下
        let subchapterMindMap = this.mindMapData.children[chapterMindMapIndex].children.find(historyItem => historyItem.data.id === subchapterId)
        let subchapterMindMapIndex = this.mindMapData.children[chapterMindMapIndex].children.findIndex(historyItem => historyItem.data.id === subchapterId)
        if(subchapterMindMap) {
          
        }else{
          // 如果脑图中没有当前所属的节的子项，增加新的节
          subchapterMindMap = {
            "id": subchapter.key,
            "text": subchapter.name,
          }
          this.mindMapData.children[chapterMindMapIndex].children.push({
            "data": subchapterMindMap,
            "children": [],
          })
          subchapterMindMapIndex = this.mindMapData.children[chapterMindMapIndex].children.length - 1
        }
        // 判断脑图数据中是否已经有该项内容
        // let itemMindMap = this.mindMapData.children[chapterMindMapIndex].children.find(historyItem => historyItem.data.id === item.id)
        let itemMindMap = false
        if(itemMindMap) {
          let activeIndex = this.mindMapData.children[chapterMindMapIndex].children.findIndex(historyItem => historyItem.data.id === item.id)
          this.mindMapData.children[chapterMindMapIndex].children.splice(activeIndex, 1)
          return false
        }
        
        let newData = {
          "id": item.id,
          "text": item.content,
          "type": "highlight",
        }
        if(item.note) {
          newData.type = "note"
          // newData.note = item.note
          newData.text = item.note
        }
        
        this.mindMapData.children[chapterMindMapIndex].children[subchapterMindMapIndex].children.push({
          "data": newData
        })
        // subchapterMindMap.children.push({
        //   "data": newData
        // })
      }else{
        // let itemMindMap = this.mindMapData.children[chapterMindMapIndex].children.find(historyItem => historyItem.data.id === item.id)
        let itemMindMap = false
        if(itemMindMap) {
          let activeIndex = this.mindMapData.children[chapterMindMapIndex].children.findIndex(historyItem => historyItem.data.id === item.id)
          this.mindMapData.children[chapterMindMapIndex].children.splice(activeIndex, 1)
          return false
        }
        
        let newData = {
          "id": item.id,
          "text": item.content,
          "type": "highlight",
        }
        if(item.note) {
          newData.type = "note"
          // newData.note = item.note
          newData.text = item.note
        }
        
        this.mindMapData.children[chapterMindMapIndex].children.push({
          "data": newData
        })
      }
      setMindMap(JSON.stringify(this.mindMapData))
      let markIndex = this.markList.findIndex(opt => opt.id === item.id)
      this.$set(this.markList[markIndex], 'isMindMap', 1)
      setMarkList(JSON.stringify(this.markList))
      this.mindMapShowHanle();
    },
    mindMapUpdate(data) {
      this.mindMapData = data
    },
    // 删除脑图中指定的项
    mindMapDelete(arr, id) {
      for (let i = 0; i < arr.children.length; i++) {
        if (arr.children[i].data.id === id) {
          arr.children.splice(i, 1);
        } else if (arr.children[i].children && arr.children[i].children.length > 0) {
          const found = this.mindMapDelete(arr.children[i], id);
          if (found) {
            arr.children.splice(i, 1, found);
          }
        }
      }
      return arr;
    },
    // 根据选中的内容找到所在的章节
    findChapter(item) {
      if(item.activeChapter.indexOf('sub') < 0) {
        return {
          chapter: item.activeChapter,
          subchapter: ''
        }
      }else{
        return {
          chapter: item.activeChapter.split('sub')[0],
          subchapter: item.activeChapter
        }
      }

      return
      let startParentNode = this.getParentNode(item.startNodeId)
      // if(startParentNode)
      if(startParentNode.nodeName === 'H3') {
        return {
          chapter: startParentNode.id,
          subchapter: ''
        }
      }else{
        return this.findSubchapterElement(startParentNode)
      }

      // return chapter
    },
    // 获取最近的h4 即节
    findSubchapterElement(node) {
      if(!node) {
        return {
          chapter: '',
          subchapter: ''
        }
      }
      if(node.nodeName === 'H3' || node.nodeName === 'H2' || node.nodeName === 'H1') {
        return {
          chapter: node.id,
          subchapter: ''
        }
      } else if(node.nodeName === 'H4') {
        let chapterId = this.findChapterElement(node)
        return {
          chapter: chapterId,
          subchapter: node.id
        }
      }else{
        return this.findSubchapterElement(node.previousElementSibling)
      }
    },
    // 获取最近的h3 即章
    findChapterElement(node) {
      if(node.nodeName === 'H3') {
        return node.id
      }else{
        return this.findChapterElement(node.previousElementSibling)
      }
    },
    // 删除脑图内容
    deleteMind(id) {
      let activeIndex = this.mindMapData.children.findIndex(item => item.data.id === id)
      this.mindMapData.children.splice(activeIndex, 1)
      this.$refs.mindMap.updateMindMap()
    },
    fontSizeChange(value) {
        // 在这里处理字体大小的变化
        let oldFontSize = 20; // 初始文字大小
        if(this.$route.query.book_id == 2) {
          oldFontSize = 24
        }
        const changeVal = (50 + value) / 100; // 变化的值
        const newFontSizeVal = oldFontSize * changeVal; //新字体大小
        const pElements = this.$refs.bookContent.$el.querySelectorAll('p') || []
        pElements.forEach(item => {
          item.style.fontSize = newFontSizeVal + 'px'; // 设置字体为最新计算出来的大小
          // item.style.textIndent = newFontSizeVal * 2 + 'px'; // 设置首行缩进
          if(this.$route.query.book_id == 2) {
            item.style.lineHeight = 1.5 * newFontSizeVal + 'px'; // 设置行高
          }

          let spanElement = item.querySelectorAll('span')
          spanElement.forEach(spanItem => {
            spanItem.style.fontSize = newFontSizeVal + 'px'; // 设置字体为最新计算出来的大小
          })
        });
        this.fontSizeChangeVal = value; // 记录字体大小
        // $(".content_box>p").css("font-size", newFontSizeVal); // 设置字体为最新计算出来的大小
        // $(".content_box>p").css("text-indent", newFontSizeVal * 2); // 设置首行缩进

        // // 移动设备,调整字体大小
        // if (this.isMobile()) {
        //   const oldFontSize = 24; // 初始文字大小
        //   const newFontSizeVal = oldFontSize * changeVal; //新字体大小
        //   $("#app .read-content .content_box>p").css(
        //     "font-size",
        //     newFontSizeVal / 100 + 0.08 + "rem"
        //   ); // 设置字体为最新计算出来的大小
        //   $("#app .read-content .content_box>p").css(
        //     "text-indent",
        //     (newFontSizeVal * 2) / 100 + 0.08 + "rem"
        //   ); // 设置首行缩进
        // }
    },
    backgroundColorChange(backgroundColor) {
      document.querySelector('.read-content').style.backgroundColor = backgroundColor
    },
    checkSelection(type) {
      // 选区选中后点击延迟获取当前选区，避免获取到前一选区状态
      setTimeout(() => {
        const selection = window.getSelection();
        let isEdit = true;
        if(selection.baseNode) {
          isEdit = selection.baseNode.parentElement.contentEditable == 'true'
        }
        
        if (selection.type === 'Range' && !isEdit && selection.rangeCount > 0 && !selection.isCollapsed && this.isTextSelected(document.getElementById("read-content"))) {
          // 获取选区的范围
          const range = selection.getRangeAt(0);

          // 获取选区的起始和结束节点
          const startNode =
            range.startContainer.nodeType === 3
              ? range.startContainer.parentNode
              : range.startContainer;
          const endNode =
            range.endContainer.nodeType === 3
              ? range.endContainer.parentNode
              : range.endContainer;
          // 获取选区的起始和结束的 <p> 标签
          this.startP = this.findParentP(startNode);
          this.endP = this.findParentP(endNode);
          if(startNode && this.activeChapter.indexOf('sub') >= 0) {
            this.findChapterFrom(startNode)
          }
          // 获取选中的文本范围
          const rect = range.getBoundingClientRect();
          // 计算气泡的位置
          // const normal_t = rect.top - 40 - 15; // 减去气泡高度和额外间距
          // const normal_l = rect.left + rect.width / 2 - 320 / 2; // 居中显示气泡
          const contentScrollTop = this.$refs.bookContent.$el.parentNode.scrollTop // 电子书滚动距离
          const contentLeft = this.$refs.bookContent.$el.parentNode.getBoundingClientRect().left // 电子书距离屏幕左侧距离
          const normal_t = contentScrollTop + rect.top - 70 - 40 - 15; // 减去气泡高度和额外间距
          const normal_l = rect.left - contentLeft + rect.width / 2 - 320 / 2; // 居中显示气泡
          // 计算气泡的最大允许位置
          let maxTop = contentScrollTop + window.innerHeight - 46;
          // let maxLeft = window.innerWidth - 320;
          let maxLeft = 740 - 320;
          // 限制气泡位置
          this.bubbleTop = Math.min(normal_t, maxTop);
          this.bubbleLeft = Math.min(normal_l, maxLeft);
          // 确保气泡不会出现在视口之外（考虑左侧和上侧）
          if (this.bubbleTop < 0) {
            this.bubbleTop = 0;
          }
          if (this.bubbleLeft < 0) {
            this.bubbleLeft = 0;
          }
          //app-笔记
          if (type == 1) {
            this.markSelection("note");
          } else if (type == 2) {
            //app-标记
            this.markSelection("highlight");
          } else if (type == 3) {
            //app-复制
            this.copyTxt();
          } else if (type == 4) {
            //app-纠错
            this.fillError();
          } else {
            //pc
            this.isBubbleVisible = true;
          }
        }
        else {
          // 如果没有选中文本，隐藏气泡
          this.isBubbleVisible = false;
        }
      })
    },
    findParentP(node) {
      // 查找节点的最近的 <p> 祖先节点
      while (node !== null && node.tagName !== "P") {
        node = node.parentNode;
      }
      return node;
    },
    // 检测文本是否被选中
    isTextSelected(el) {
      var sel;
      if (window.getSelection) {
        sel = window.getSelection();
        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
          if (el.contains(sel.getRangeAt(i).commonAncestorContainer)) {
            return true;
          }
        }
      } else if ((sel = document.selection) && sel.type != "Control") {
        return true;
      }
      return false;
    },
    // 是否包含某个class
    isSelectedContentHasClass(className) {
      const selection = window.getSelection();
      if (selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
        const clonedContents = range.cloneContents();

        // 遍历克隆内容中的所有元素节点
        const elements = clonedContents.querySelectorAll("*");
        for (const element of elements) {
          // 检查每个元素是否包含指定的类名
          if (element.classList.contains(className)) {
            return true; // 发现匹配的类名，返回true
          }
        }
      }
      return false; // 未发现匹配的类名，返回false
    },
    // 是否已经存在标记   
    isMarkedContent() {
      const selection = window.getSelection();
      if (selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
        const parentElement = this.getSelectedParentElement(range);
        if (parentElement && parentElement.getAttribute("data-mark")) {
          let markType = parentElement.getAttribute("data-mark-type");
          return markType; // 发现匹配的类名，返回mark类型
          return true; // 发现匹配的类名，返回true
        }
        const clonedContents = range.cloneContents();
        // 遍历克隆内容中的所有元素节点
        const elements = clonedContents.querySelectorAll("*");
        for (const element of elements) {
          // 检查每个元素是否包含指定的类名
          if (element && element.getAttribute("data-mark")) {
            let markType = element.getAttribute("data-mark-type");
            return markType; // 发现匹配的类名，返回mark类型
            return true; // 发现匹配的类名，返回true
          }
        }
      }
      return false; // 未发现匹配的类名，返回false
    },
    // 获取选中元素的父元素
    getSelectedParentElement(range) {
      const parentElement = range.commonAncestorContainer;
      // 如果父元素就是所需的元素，直接返回
      if (parentElement instanceof HTMLElement) {
        return parentElement;
      }
      // 否则向上查找直到找到最近的父元素
      let current = parentElement.parentNode;
      while (current) {
        if (current instanceof HTMLElement) {
          return current;
        }
        current = current.parentNode;
      }
      return null
    },
    // 笔记弹窗绑定文本框的值
    changeNoteTextarea(val) {
      this.noteTextareaContent = val
    },
    // 笔记弹窗 提交事件
    submitNote(type) {
      if(type === 'add') {
        this.noteAddParam.note = this.noteTextareaContent
        this.markList.unshift(this.noteAddParam)
        setMarkList(JSON.stringify(this.markList))
        this.loadSingleMark(
          this.noteAddParam.id,
          this.noteAddParam.type,
          this.noteAddParam.startNodeId,
          this.noteAddParam.endNodeId,
          this.noteAddParam.startNodeOffset,
          this.noteAddParam.endNodeOffset,
          this.selectedText,
          this.noteAddParam.updateTime,
          this.noteAddParam.activeChapterName,
          0,
          this.noteTextareaContent
        )
      }else if(type === 'edit') {
        let editIndex = this.markList.findIndex(item => item.id == this.randomValue)
        this.markList[editIndex].note = this.noteTextareaContent
        this.markList[editIndex].updateTime = this.getCurrentTime()
        setMarkList(JSON.stringify(this.markList))
      }
      this.noteTextareaContent = "";
      this.drawerNoteVisible = false
      this.actionRightShow = true;
      this.actionRightType = 'note';
    },
    // 取消写笔记
    cancelSubmitNote(type) {
      if (type === "add") {
        // console.log(document.getElementById(this.randomValue))
        // this.removeMarks(document.getElementById(this.randomValue));
        this.drawerNoteVisible = false;
        this.noteTextareaContent = "";
      } else {
        this.drawerNoteVisible = false;
        this.noteTextareaContent = "";
      }
    },
    // 点击笔记标识，打开笔记列表
    openNoteList() {
      this.$nextTick(() => {
        this.actionRightShow = true;
        this.actionRightType = 'note';
        // const element = document.getElementById(`${id_val}`);
        const element = event.target
        if (element != null) {
          this.activeNote = element.id
          // setTimeout(function () {
          //   element.scrollIntoView({
          //     behavior: "smooth", // 平滑滚动
          //     block: "center", // 垂直居中
          //   });
          // }, 20);
        } else {
        }
      });
    },
    // 加载全部标记
    async loadMarks() {
      this.markList = JSON.parse(getMarkList()) || [];
      let markListArr = JSON.parse(JSON.stringify(this.markList))
      markListArr = markListArr.filter(item => item.activeChapterKey === this.activeChapterKey)
      markListArr.reverse();
      for(let i = 0; i < markListArr.length; i++) {
        let {id, type, startNodeId, endNodeId, startNodeOffset, endNodeOffset, content: selectedText, updateTime } = markListArr[i];
        await this.sequentialMethod(id, type, startNodeId, endNodeId, startNodeOffset, endNodeOffset, selectedText, updateTime, i);
      }
    },
    sequentialMethod(id, type, startNodeId, endNodeId, startNodeOffset, endNodeOffset, selectedText, updateTime, i) {
      // 这里是你想要在每次迭代中执行的异步方法
      return new Promise((resolve) => {
        // 模拟异步操作，如AJAX请求等
        this.$nextTick(() => {
          setTimeout(() => {
            this.loadSingleMark(id, type, startNodeId, endNodeId, startNodeOffset, endNodeOffset, selectedText, updateTime, i);
            resolve();
          }, 100)
        })
      });
    },
    // 标记单个元素插入 type 高亮：highlight、笔记：note
    loadSingleMark(id, type, startNodeId, endNodeId, startNodeOffset, endNodeOffset, selectedTextAll, updateTime, index, note) {
      let allElement = this.getAllElement(startNodeId, endNodeId, endNodeOffset)
      let canMarkElement = this.findCanMarkElement(allElement);
      // 生成一个随机数用作属性值
      // this.randomValue = Math.random().toString(36).substring(2, 15);
      let selectedText = ''
      let canMarkHtml = ''
      for(let i = 0; i < canMarkElement.length; i++) {
        let newMarkEl = document.createElement("span");
        // 设置高亮、笔记的样式
        if(type === 'highlight') {
          newMarkEl.style.backgroundColor = "yellow";
          newMarkEl.style.color = "black";
          newMarkEl.setAttribute("data-mark-type", 'highlight');
        }else if(type === 'note') {
          newMarkEl.style.textDecoration = "underline";
          // 设置有笔记标识的地方，点击打开笔记列表
          newMarkEl.setAttribute("onclick", "openNoteList()");
          newMarkEl.setAttribute("data-mark-type", 'note');
        }
        newMarkEl.style.userSelect = "text";
        newMarkEl.setAttribute("data-mark", id);

        // 设置唯一
        newMarkEl.setAttribute("id", id);
        selectedText = canMarkElement[i].textContent;
        if(startNodeId === endNodeId) {
          if(canMarkElement[i].childNodes.length > 1) {
            for(let j = 0; j < canMarkElement[i].childNodes.length; j++) {
              if(canMarkElement[i].childNodes[j].nodeType === 3) {
                selectedText = canMarkElement[i].childNodes[j].textContent
                if(selectedText.substring(startNodeOffset, endNodeOffset) === selectedTextAll) {
                  newMarkEl.innerHTML = selectedText.substring(startNodeOffset, endNodeOffset);
                  let canMarkHtml = selectedText.substring(0, startNodeOffset) + newMarkEl.outerHTML + selectedText.substring(endNodeOffset, selectedText.length)
                  this.$nextTick(() => {
                    setTimeout(() => {
                      canMarkElement[i].innerHTML = canMarkElement[i].innerHTML.replace(canMarkElement[i].childNodes[j].nodeValue, canMarkHtml)
                      this.$forceUpdate()
                    }, 100)
                  })
                }
              } 
            }
          }else{
            selectedText = canMarkElement[i].childNodes[0].textContent
            newMarkEl.innerHTML = selectedText.substring(startNodeOffset, endNodeOffset);
            let canMarkHtml = selectedText.substring(0, startNodeOffset) + newMarkEl.outerHTML + selectedText.substring(endNodeOffset, selectedText.length)
            this.$nextTick(() => {
              setTimeout(() => {
                canMarkElement[i].innerHTML = canMarkHtml
                this.$forceUpdate()
              }, 100)
            })
          }
          // selectedText = selectedText.substring(startNodeOffset, endNodeOffset)
        } else if(startNodeId === canMarkElement[i].id) {
          if(canMarkElement[i].childNodes.length > 1) {
            let allChildNodes = Array.prototype.slice.call(canMarkElement[i].childNodes);
            let textChildrenNodes = allChildNodes.filter(item => item.nodeType === 3)
            selectedText = textChildrenNodes[textChildrenNodes.length - 1].textContent
            newMarkEl.innerHTML = selectedText.substring(startNodeOffset, selectedText.length)
            let canMarkHtml = selectedText.substring(0, startNodeOffset) + newMarkEl.outerHTML
            this.$nextTick(() => {
              setTimeout(() => {
                canMarkElement[i].innerHTML = canMarkElement[i].innerHTML.replace(textChildrenNodes[textChildrenNodes.length - 1].nodeValue, canMarkHtml)
                this.$forceUpdate()
              }, 100)
            })
          }else{
            selectedText = canMarkElement[i].childNodes[0].textContent
            newMarkEl.innerHTML = selectedText.substring(startNodeOffset, selectedText.length)
            let canMarkHtml = selectedText.substring(0, startNodeOffset) + newMarkEl.outerHTML
            this.$nextTick(() => {
              setTimeout(() => {
                canMarkElement[i].innerHTML = canMarkHtml
                this.$forceUpdate()
              }, 100)
            })
          }
        }else if(endNodeId === canMarkElement[i].id) {
          if(endNodeOffset > 0) {
            if(canMarkElement[i].childNodes.length > 1) {
              let allChildNodes = Array.prototype.slice.call(canMarkElement[i].childNodes);
              let textChildrenNodes = allChildNodes.filter(item => item.nodeType === 3)
              selectedText = textChildrenNodes[0].textContent
              newMarkEl.innerHTML = selectedText.substring(0, endNodeOffset)
              let canMarkHtml = newMarkEl.outerHTML + selectedText.substring(endNodeOffset, selectedText.length)
              this.$nextTick(() => {
                setTimeout(() => {
                  canMarkElement[i].innerHTML = canMarkElement[i].innerHTML.replace(textChildrenNodes[0].nodeValue, canMarkHtml)
                  // this.$forceUpdate()
                }, 100)
              })
            }else{
              selectedText = canMarkElement[i].childNodes[0].textContent
              newMarkEl.innerHTML = selectedText.substring(0, endNodeOffset)
              let canMarkHtml = newMarkEl.outerHTML + selectedText.substring(endNodeOffset, selectedText.length)
              this.$nextTick(() => {
                setTimeout(() => {
                  canMarkElement[i].innerHTML = canMarkHtml
                  this.$forceUpdate()
                }, 100)
              })
            }
          }else{
            selectedText = ''
          }
        }else{
          selectedText = canMarkElement[i].textContent;
          newMarkEl.innerHTML = canMarkElement[i].textContent;
          let canMarkHtml = newMarkEl.outerHTML
          this.$nextTick(() => {
            setTimeout(() => {
              canMarkElement[i].innerHTML = canMarkHtml
              this.$forceUpdate()
            }, 100)
          })
        }
      }
    },
    // 标记单个元素插入 type 高亮：highlight、笔记：note
    loadSingleMark1(id, type, startNodeId, endNodeId, startNodeOffset, endNodeOffset, selectedTextAll, updateTime, index, note) {
      let allElement = this.getAllElement(startNodeId, endNodeId, endNodeOffset)
      let canMarkElement = this.findCanMarkElement(allElement);
      // 生成一个随机数用作属性值
      // this.randomValue = Math.random().toString(36).substring(2, 15);
      let selectedText = ''
      for(let i = 0; i < canMarkElement.length; i++) {
        let newMarkEl = document.createElement("span");
        // 设置高亮、笔记的样式
        if(type === 'highlight') {
          newMarkEl.style.backgroundColor = "yellow";
          newMarkEl.style.color = "black";
          newMarkEl.setAttribute("data-mark-type", 'highlight');
        }else if(type === 'note') {
          newMarkEl.style.textDecoration = "underline";
          // 设置有笔记标识的地方，点击打开笔记列表
          newMarkEl.setAttribute("onclick", "openNoteList()");
          newMarkEl.setAttribute("data-mark-type", 'note');
        }
        newMarkEl.style.userSelect = "text";
        newMarkEl.setAttribute("data-mark", id);

        // 设置唯一
        newMarkEl.setAttribute("id", id);
        selectedText = canMarkElement[i].textContent;
        if(startNodeId === endNodeId) {
          if(canMarkElement[i].childNodes.length > 1) {
            for(let j = 0; j < canMarkElement[i].childNodes.length; j++) {
              if(canMarkElement[i].childNodes[j].nodeType === 3 && canMarkElement[i].childNodes[j].textContent.indexOf(selectedTextAll) > -1) {
                selectedText = canMarkElement[i].childNodes[j].textContent
              } 
            }
          }
          selectedText = selectedText.substring(startNodeOffset, endNodeOffset)
        } else if(startNodeId === canMarkElement[i].id) {
          if(canMarkElement[i].childNodes.length > 1) {
            let allChildNodes = Array.prototype.slice.call(canMarkElement[i].childNodes);
            let textChildrenNodes = allChildNodes.filter(item => item.nodeType === 3)
            selectedText = textChildrenNodes[textChildrenNodes.length - 1].textContent
          }
          selectedText = selectedText.substring(startNodeOffset, selectedText.length)
        }else if(endNodeId === canMarkElement[i].id) {
          if(endNodeOffset > 0) {
            if(canMarkElement[i].childNodes.length > 1) {
              let allChildNodes = Array.prototype.slice.call(canMarkElement[i].childNodes);
              let textChildrenNodes = allChildNodes.filter(item => item.nodeType === 3)
              selectedText = textChildrenNodes[0].textContent
            }
            selectedText = selectedText.substring(0, endNodeOffset)
          }else{
            selectedText = ''
          }
        }else{
          selectedText = canMarkElement[i].textContent;
        }
        if(selectedText) {
          let canmarkHtml = document.getElementById(canMarkElement[i].id).innerHTML;
          newMarkEl.innerHTML = selectedText;
          document.getElementById(canMarkElement[i].id).innerHTML = canmarkHtml.replace(selectedText, newMarkEl.outerHTML);
        }
      }
    },
    
    // 标记 -- 标记选中的文本,并追加到标记列表中
    // type highlight:高亮 note:笔记
    markSelection(type) {
      // const classNameToCheck = "el-popover__reference";
      // if (this.isSelectedContentHasClass(classNameToCheck)) {
      //   this.$message({
      //     message: "冒泡内容不可选中!",
      //     type: "error",
      //     duration: 2000,
      //   });
      //   return false
      // } else 
      if (this.isMarkedContent()) {
        let messageType = this.isMarkedContent()
        this.$message({
          message: `当前区域已有${messageType === 'highlight' ? '标记' : '笔记'}，请移除后再重新添加!`,
          type: "error",
          duration: 2000,
        });
        return false
      } else {
        let selection = window.getSelection();
        let range = selection.getRangeAt(0);

        let startNode = range.startContainer.tagName === 'P' ? range.startContainer : range.startContainer.parentElement;
        let endNode = range.endContainer.tagName === 'P' ? range.endContainer : range.endContainer.parentElement;

        let startNodeId = startNode.id;
        let startNodeOffset = range.startOffset;
        let endNodeId = endNode.id;
        let endNodeOffset = range.endOffset;
        
        let startChangeText = range.startContainer.textContent
        let endChangeText = range.endContainer.textContent

        let allElement = this.getAllElement(startNodeId, endNodeId, endNodeOffset)
        let canMarkElement = this.findCanMarkElement(allElement);
        // 生成一个随机数用作属性值
        this.randomValue = Math.random().toString(36).substring(2, 15);

        this.selectedText = '';
        let selectedText = ''
        for(let i = 0; i < canMarkElement.length; i++) {
          if(startNodeId === endNodeId) {
            selectedText = startChangeText;
            selectedText = selectedText.substring(startNodeOffset, endNodeOffset)
            this.selectedText = selectedText;
            break;
          } else if(startNodeId === canMarkElement[i].id) {
            selectedText = startChangeText;
            selectedText = selectedText.substring(startNodeOffset, selectedText.length)
          }else if(endNodeId === canMarkElement[i].id) {
            selectedText = endChangeText;
            selectedText = selectedText.substring(0, endNodeOffset)
          }else{
            selectedText = canMarkElement[i].textContent;
          }
          this.selectedText += selectedText;
        }
        let activeChapterName = this.findChapterName(this.activeChapter)
        let newMark = {
          id: this.randomValue,
          type,
          startNodeId,
          endNodeId,
          startNodeOffset,
          endNodeOffset,
          content: this.selectedText,
          updateTime: this.getCurrentTime(),
          isMindMap: 0,
          activeChapter: this.activeChapter,
          activeChapterKey: this.activeChapterKey,
          activeChapterName
        }
        if(type === 'highlight') {
          this.markList.unshift(newMark)
          setMarkList(JSON.stringify(this.markList))

          this.loadSingleMark(
            this.randomValue,
            type,
            startNodeId,
            endNodeId,
            startNodeOffset,
            endNodeOffset,
            this.selectedText,
            newMark.updateTime,
            activeChapterName,
            0
          )
          this.actionRightType = 'highlight';
        }else if(type === 'note'){
          this.drawerNoteVisible = true;
          this.noteDrawerType = 'add'
          this.noteAddParam = newMark
          this.actionRightType = 'note';
        }

        this.actionRightShow = true;

        // 取消选区
        selection.removeAllRanges();
        this.isBubbleVisible = false;
      }
    },
    editNote(id) {
      this.drawerNoteVisible = true
      let editItem = this.markList.find(item => item.id == id)
      this.randomValue = id;
      this.selectedText = editItem.content
      this.noteTextareaContent = editItem.note
      this.activeNote = id
      this.noteDrawerType = 'edit'
    },
    readMarkFile() {
      // const data = require('./markFile.json');
      // console.log(data)
      // this.writeMarkFile();
      // fs.readFile('./components/sideBarRight/markFile.json', 'utf8', (err, data) => {
      //   if(err) {
      //     console.log(err)
      //     throw err
      //   }
      //   // 解析为JavaScript对象
      //   const jsonObject = JSON.parse(data);
      //   console.log(jsonObject)
      // })
    },
    writeMarkFile(jsonObject) {
      // 假设我们要修改的JSON文件位于src/assets目录
      const jsonFilePath = './markFile.json';
 
      // 使用require来获取文件的路径
      const jsonData = require(jsonFilePath);
 
      // 修改JSON数据
      jsonData.newData = 'New Value';
 
      // 导出修改后的数据以便写入文件
      require.ensure([], () => {
        // 清除缓存
        delete require.cache[require.resolve(jsonFilePath)];
 
        // 写入新的数据到文件
        require(jsonFilePath).default = jsonData;
      });

      setTimeout(() => {
        const data = require('./markFile.json');
      }, 3000)

      // axios.put('./markFile', { data: jsonObject }).then(res =>{
      //   console.log(res)
      // }).catch(err => {
      //   console.log(err)
      // })
      // fs.writeFile('./markFile.json', JSON.stringify(jsonObject, null, 2), 'utf8', (err) => {
      //   if (err) {
      //     throw err;
      //   }
      //   console.log('文件已成功修改。');
      // });
    },
    // 获取某个章节key对应的名称
    findChapterName(key) {
      let name = ''
      this.navBarData.forEach(item => {
        if(item.key === key) {
          name = item.name
        }
        if(item.children && item.children.length > 0) {
          item.children.forEach(sub => {
            if(sub.key === key) {
              name = sub.name
            }
          })
        }
      })
      return name
    },
    // 获取某两个id之间的所有元素
    getAllElement(startId, endId, endNodeOffset, actionId, allNodes) {
      // if(startId === endId) {
      //   return [document.getElementById(startId)]
      // }
      let newAllNodes = []
      let startParentNode = this.getParentNode(startId)
      let endParentNode = this.getParentNode(endId)
      let actionParentNode = null
      if(!actionId) {
        newAllNodes = startParentNode.querySelectorAll('*') || [];
        // newAllNodes = startParentNode.childNodes || [];
        // newAllNodes = this.getAllChildrenNodes(startParentNode);
        let startNodeIndex = 0
        let endNodeIndex = 0
        for(let i = 0; i < newAllNodes.length; i++) {
          if(newAllNodes[i].id && newAllNodes[i].id == startId) {
            startNodeIndex = i
          }
          if(newAllNodes[i].id && newAllNodes[i].id == endId) {
            endNodeIndex = i
          }
        }
        if(startParentNode === endParentNode) {
          newAllNodes = Array.prototype.slice.call(newAllNodes, startNodeIndex, endNodeIndex + 1);
        }else{
          newAllNodes = Array.prototype.slice.call(newAllNodes, startNodeIndex);
        }
        newAllNodes.push(startParentNode)
      }else if(actionId === endParentNode.id) {
        if(endNodeOffset > 0) {
          actionParentNode = document.getElementById(actionId)
          newAllNodes = endParentNode.querySelectorAll('*') || [];
          // newAllNodes = endParentNode.childNodes || [];
          let endNodeIndex = null
          for(let i = 0; i < newAllNodes.length; i++) {
            if(newAllNodes[i].id && newAllNodes[i].id == endId) {
              endNodeIndex = i
            }
          }
          newAllNodes = Array.prototype.slice.call(newAllNodes);
          newAllNodes.splice(endNodeIndex + 1, newAllNodes.length)
          newAllNodes.push(endParentNode)
        }else{
          newAllNodes = []
        }
      }else{
        actionParentNode = document.getElementById(actionId)
        newAllNodes = actionParentNode.querySelectorAll('*') || [];
        // newAllNodes = actionParentNode.childNodes || [];
        newAllNodes = Array.prototype.slice.call(newAllNodes);
        newAllNodes.push(actionParentNode)
      }
      // let startParentNode = this.getParentNode(startId)
      // newAllNodes = startParentNode.querySelectorAll('*');
      newAllNodes = [...(allNodes || []), ...newAllNodes]
      if(startParentNode.id === endParentNode.id || actionId === endParentNode.id) {
        return newAllNodes;
      }else{
        let newStartId = (actionParentNode || startParentNode).nextElementSibling.id;
        return this.getAllElement(startId, endId, endNodeOffset, newStartId, newAllNodes);
      }
    },
    // 获取某一节点下的所有节点
    getAllChildrenNodes(node) {
      let nodes = node.childNodes
      let allNodes = []
      if(nodes.length === 1 && nodes[0].nodeType === 3) {
        return []
      }else{
        for(let i = 0; i < nodes.length; i++) {
          if(nodes[i].nodeType === 3) {
            allNodes.push(nodes[i])
          }else if(nodes[i].nodeType === 1){
            let childNodes = this.getAllChildrenNodes(nodes[i])
            if(childNodes.length === 0) {
              allNodes.push(nodes[i])
            }
            allNodes = [...allNodes, ...childNodes]
          }
        }
      }
      return allNodes
    },
    // 获取某一节点下的所有节点
    // getAllChildrenNodes(node) {
    //   let nodes = node.childNodes
    //   let allNodes = []
    //   if(nodes.length === 1 && nodes[0].nodeType === 3) {
    //     return []
    //   }else{
    //     for(let i = 0; i < nodes.length; i++) {
    //       if(nodes[i].nodeType === 3) {
    //         allNodes.push(nodes[i])
    //       }else{
    //         allNodes.push(nodes[i])
    //         allNodes = [...allNodes, ...this.getAllChildrenNodes(nodes[i])]
    //       }
    //     }
    //   }
    //   return allNodes
    // },
    // 获取到该标签最顶层的父元素
    getParentNode(id, node) {
      let element = document.getElementById(id) || node;
      let parentElement = element.parentElement;
      if(parentElement.id == 'read-content') {
        return element
      }else{
        return this.getParentNode(parentElement.id, parentElement)
      }
    },
    // 筛选标签数组，返回可以被标记的数组
    findCanMarkElement(tags) {
      let canMarkTags = []
      tags.forEach(tag => {
        if(tag.id) {
          let canSelect = window.getComputedStyle(tag).userSelect !== 'none';
          if(!this.elementHasChildren(tags, tag.id) && !tag.getAttribute("data-mark") && (tag.tagName === 'P' || tag.tagName === 'SPAN') && canSelect){
            canMarkTags.push(tag)
          }
        }
      })
      return canMarkTags
    },
    // 筛选掉父级标签
    elementHasChildren(tags, id) {
      for(let tag of tags) {
        if(tag.id && tag.id !== id && tag.id.indexOf(id) > -1) {
          return true
        }
      }
      return false
    },
    // 阻止默认的复制事件
    copyPrevent(event) {
      if(event.target.id == 'textCanCopy') {
        return false;
      }
      event.preventDefault();
      event.clipboardData.setData('text/plain', '');
    },
    // 复制
    copyTxt() {
      const textAreaStr = this.getSelectedTxt() || '';
      if(textAreaStr.length > 150) {
        this.$message({
          message: "复制内容不能超过150个字！",
          type: "error",
          duration: 2000,
        });
        return false;
      }
      const textArea = document.createElement("textarea");
      textArea.id = 'textCanCopy';
      textArea.value = textAreaStr;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
        this.isBubbleVisible = false;
        this.$message({
          message: "复制成功！",
          type: "success",
          duration: 2000,
        });
      } catch (err) {
        console.error('Unable to copy to clipboard', err);
      }
      document.body.removeChild(textArea);
    },
    // 获取选区文本
    getSelectedTxt() {
      if (this.isTextSelected(document.getElementById("read-content"))) {
        var selection = window.getSelection();
        var range = selection.getRangeAt(0);
        var highlight = document.createElement("span");

        // 克隆选区范围
        var clone = range.cloneContents();
        // 将克隆的内容插入到新建元素中
        highlight.appendChild(clone);
        this.selectedText = highlight.innerText;
        // 取消选区
        // selection.removeAllRanges();

        // 返回选中文本
        return this.selectedText;
      }
    },
    // 纠错
    fillError() {
      this.drawerFillError = true
    },
    // 隐藏纠错弹窗
    cancelFillError() {
      this.drawerFillError = false
    },
    // 字典
    toDictionary() {
      const textAreaStr = this.getSelectedTxt() || '';
      if(textAreaStr) {
        window.open(`https://hanyu.baidu.com/hanyu-page/term/detail?wd=${textAreaStr}&device=pc&from=home`)
      }
      // this.isBubbleVisible = false;
    },
    // 百科
    toBaike() {
      const textAreaStr = this.getSelectedTxt() || '';
      if(textAreaStr) {
        window.open(`https://baike.baidu.com/search?word=${textAreaStr}&rn=10&enc=utf8&onlySite=1`)
      }
      // this.isBubbleVisible = false;
    },
    // 点击高亮列表，跳转到对应高亮处
    goLocation(data_mark) {
      // 导航滚动定位
      this.scrollToElement(data_mark);
      this.activeMark = data_mark
    },

    // 笔记列表和标记列表的删除事件
    delRecordLi(id) {
      let actionIndex = ''
      
      // 删除条目的二次确认对话框
      this.$confirm("确定要删除当前数据？")
        .then(() => {
          actionIndex = this.markList.findIndex(item => item.id == id)
          
          var mark_obj_arr = document.getElementsByTagName('span');
          mark_obj_arr = Array.prototype.slice.call(mark_obj_arr);
          for (var i = 0; i < mark_obj_arr.length; i++) {
            if (mark_obj_arr[i].getAttribute("data-mark") == id) {
              
              let deleteElement = mark_obj_arr[i]
              // 获取同级的后一元素 并修改其定位
              let nextElement = deleteElement.nextElementSibling;
              let levelElement = deleteElement.parentNode.childNodes
              let endNodeOffset = 0
              for(let j = 0; j < levelElement.length; j++) {
                if(levelElement[j].id === id) {
                  endNodeOffset += levelElement[j].textContent.length
                  if(j > 0 && !levelElement[j-1].id) {
                    endNodeOffset += levelElement[j-1].textContent.length
                  }
                }
              }
              // 同级存在其他标记，重新定位位置
              if(nextElement) {
                let nextMarkIndex = this.markList.findIndex(item => item.id == nextElement.id)
                if(actionIndex > nextMarkIndex && nextMarkIndex > -1) {
                  let newStartNodeOffset = this.markList[nextMarkIndex].startNodeOffset + endNodeOffset
                  let newEndNodeOffset = this.markList[nextMarkIndex].endNodeOffset + endNodeOffset
                  this.$set(this.markList[nextMarkIndex], 'startNodeOffset', newStartNodeOffset)
                  this.$set(this.markList[nextMarkIndex], 'endNodeOffset', newEndNodeOffset)
                }
              }

              // 清除文中被标记的标识
              this.removeMarks(mark_obj_arr[i]);
            }
          }

          this.markList.splice(actionIndex, 1)
          setMarkList(JSON.stringify(this.markList))
        })
    },
    // 取消高亮或笔记
    removeMarks(this_span) {
      this_span.parentNode.innerHTML = this_span.parentNode.innerHTML.replace(this_span.outerHTML, this_span.innerHTML);
      // const new_span = document.createElement("span"); // 创建一个新的span
      // new_span.style.userSelect = "text";
      // new_span.style.textDecoration = "none";
      // new_span.innerHTML = this_span.innerHTML; // 把this_span中的html 赋值给新的span
      // this_span.parentNode.insertBefore(new_span, this_span); // 在 this_span 节点前插入新span节点
      // this_span.remove(); // 移除this_span
    },
    // 表格切换
    tableTabChange(tableKey, tableTabKey) {
      this.$refs.bookContent.tableTabChange(tableKey, tableTabKey)
    },
    // 滚到到指定的百分比位置
    scrollToPercent(percent) {
      setTimeout(() => {
        this.$nextTick(() => {
          let element = document.getElementById('read-content');
          const totalHeight = element.scrollHeight;
          const clientHeight = element.clientHeight;
          if(totalHeight === clientHeight) {
            this.readPercentage = 100;     
            this.updateReadPercent(this.activeChapter, 100);
          }else{
            const scrollTop = (percent / 100) * (totalHeight - clientHeight);
            element.scrollTop = scrollTop;
          }
        })
      }, 300)
    },
    // 滚到到指定的百分比位置
    scrollToPosition(position) {
      setTimeout(() => {
        this.$nextTick(() => {
          let element = document.getElementById('read-content');
          const totalHeight = element.scrollHeight;
          const clientHeight = element.clientHeight;
          if(totalHeight === clientHeight) {
            this.readPercentage = 100;     
            this.updateReadPercent(this.activeChapter, 100);
          }else{
            element.scrollTop = position;
          }
        })
      }, 300)
    },
    // 默认的学习进度数据，初始数据
    loadReadPercent() {
      this.readPercentData = {
        nowPercent: 0, // 当前进度 学习记录
        studyPercent: 0, // 学习进度 总进度
        activeChapter: this.activeChapter,
        children: []
      }
      // this.readPercentData.children = this.navBarData.filter(item => item.key.indexOf('chapter') > -1).map(item => {
      this.readPercentData.children = this.navBarData.map(item => {
        item.studyPercent = 0
        if(item.children && item.children.length > 0) {
          item.children = item.children.map(child => {
            child.percent = 0;
            child.studyPercent = 0;
            return child
          })
        }else{
          item.percent = 0
        }
        return item;
      })
    },
    // 保存阅读百分比的各项数据
    updateReadPercent(activeChapter, readPercentage) {
      let totalPercent = 0
      this.readPercentData.children.forEach(chapter => {
        if(chapter.key === activeChapter) {
          chapter.percent = readPercentage;
          chapter.studyPercent = Math.max(chapter.studyPercent, readPercentage);
        }
        if(chapter.children && chapter.children.length > 0){
          let chapterTotalPercent = 0
          chapter.children.forEach(subchapter => {
            if(subchapter.key === activeChapter) {
              subchapter.percent = readPercentage;
              subchapter.studyPercent = Math.max(subchapter.studyPercent, readPercentage);
            }
            chapterTotalPercent += subchapter.studyPercent
          })
          // 取整数 或者 保留两位小数
          chapter.studyPercent = Math.round(chapterTotalPercent / chapter.children.length)
          // chapter.studyPercent = parseFloat((chapterTotalPercent / chapter.children.length).toFixed(2));
        }
        totalPercent += chapter.studyPercent
      })
      // if(activeChapter.indexOf('chapter') < 0) {

      // }
      this.readPercentData.studyPercent = Math.round(totalPercent / this.readPercentData.children.length)
      // this.readPercentData.studyPercent = parseFloat((totalPercent / this.readPercentData.children.length).toFixed(2));
      // 下次进入时进行定位
      this.readPercentData.activeChapter = activeChapter
      this.readPercentData.nowPercent = readPercentage
      setReadPercent(JSON.stringify(this.readPercentData));
    },
    handleScrollDB: debounce(function(event) {
      this.handleScroll(event)
    }, 300),
    // 页面滚动触发事件
    handleScroll(event) {
      const totalHeight = event.target.scrollHeight;
      const scrollTop = event.target.scrollTop;
      const clientHeight = event.target.clientHeight;
      if(totalHeight <= clientHeight) {
        this.readPercentage = 100;     
      }else{
        const percentage = (scrollTop / (totalHeight - clientHeight)) * 100;
        this.readPercentage = Math.round(percentage);
        // this.readPercentage = parseFloat(percentage.toFixed(2));
      }
      this.updateReadPercent(this.activeChapter, this.readPercentage)
      // if(this.activeChapter.indexOf('chapter') > -1) {
      //   this.updateReadPercent(this.activeChapter, this.readPercentage)
      // }else{
      //   this.readPercentData.activeChapter = this.activeChapter
      //   this.readPercentData.nowPercent = this.readPercentage
      //   setReadPercent(JSON.stringify(this.readPercentData));
      // }
    },

    // 页面滚动定位
    scrollToElement(index) {
      const element = document.getElementById(`${index}`);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth", // 平滑滚动
          block: "center", // 垂直居中对齐
        });
      }
    },
    // 计算当前时间
    getCurrentTime() {
      // return new Date().toLocaleString();
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0"); // 月份从0开始，所以要+1
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");

      // 拼接日期和时间字符串，使用'-'作为分隔符
      return (
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds
      );
    },
  }
}

</script>
<style lang="scss" scoped>

.page-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .page-header{
    flex: 0 0 70px;
    background: #fff;
    box-shadow: 0px 3px 8px 0px rgba(32,37,36,0.2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    z-index: 6;

    .header-left{
      display: flex;
      align-items: center;
      justify-content: space-between;
      
      .header-logo{
        width: 131px;
        height: 35px;
        margin-left: 20px;
        display: flex;
        justify-content: center;
        align-items: center;

        img{
          display: block;
          width: 100%;
          //cursor: pointer;
        }
      }

      .header-title{
        margin-left: 20px;

        h3{
          font-size: 20px;
          text-align: center;
          color: #333333;
        }
      }
    }


    .header-action{
      margin-right: 20px;

      .action-mind-map{
        display: flex;
        align-items: center;
        cursor: pointer;
        font-size: 18px;
        color: #333;

        img{
          width: 38px;
          height: 38px;
          display: block;
          margin-right: 10px;
        }
      }
    }
  }

  .page-content{
    flex: 1;
    overflow: hidden;
    display: flex;

    .actions-btn{
      width: 70px;
      line-height: 70px;
      font-size: 30px;
      text-align: center;
      color: #fff;
      cursor: pointer;
      user-select: none;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 30px;

      .actions-btn-icon{
        display: block;
        width: 30px;
        height: 30px;
        background: url("~@/assets/images/common/menu-icon.png") center center no-repeat;
        background-size: contain;
      }
    }

    .actions-btn-active{
      .actions-btn-icon{
        background-image: url("~@/assets/images/common/menu-icon-active.png");
      }
    }

    .actions-setting-btn{
      .actions-btn-icon{
        background-image: url("~@/assets/images/common/setting-icon.png");
      }
    }
    
    .actions-setting-btn.actions-btn-active{
      .actions-btn-icon{
        background-image: url("~@/assets/images/common/setting-icon-active.png");
      }
    }

    .actions-highlight-btn{
      .actions-btn-icon{
        background-image: url("~@/assets/images/common/highlight-icon.png");
      }
    }
    
    .actions-highlight-btn.actions-btn-active{
      .actions-btn-icon{
        background-image: url("~@/assets/images/common/highlight-icon-active.png");
      }
    }

    .actions-note-btn{
      .actions-btn-icon{
        background-image: url("~@/assets/images/common/note-icon.png");
      }
    }
    
    .actions-note-btn.actions-btn-active{
      .actions-btn-icon{
        background-image: url("~@/assets/images/common/note-icon-active.png");
      }
    }

    .actions-files-btn{
      .actions-btn-icon{
        background-image: url("~@/assets/images/common/files-icon.png");
      }
    }
    
    .actions-files-btn.actions-btn-active{
      .actions-btn-icon{
        background-image: url("~@/assets/images/common/files-icon-active.png");
      }
    }

    .actions-search-btn{
      .actions-btn-icon{
        background-image: url("~@/assets/images/common/search-icon.png");
      }
    }
    
    .actions-search-btn.actions-btn-active{
      .actions-btn-icon{
        background-image: url("~@/assets/images/common/search-icon-active.png");
      }
    }

    .main {
      width: calc(100% - 140px);
      position: relative;
      display: flex;
      overflow-x: auto;
  
      .action-left.hideAction {
        margin-left: -400px;
      }
  
      .action-left{
        flex: 0 0 var(--sidebar-left-width);
        width: var(--sidebar-left-width);
        height: 100%;
        border-right: 1px solid #e3e3e3;
        margin-left: 0;
        transition: margin-left 0.3s;
        z-index: 3;
        display: flex;
        flex-direction: column;
        position: relative;
        overflow: hidden;
        
        .action-left-block{
          width: 100%;
          height: 100%;
          overflow: auto;
        }
        .catalog{
          width: 400px;
          height: 100%;
          border-right: 1px solid #e3e3e3;
          margin-left: 0;
          transition: margin-left 0.3s;
          z-index: 3;
          display: flex;
          flex-direction: column;
    
          .book-info{
            padding: 20px;
            width: 400px;
            display: flex;
            align-items: center;
            position: relative;
            .book-pic-box {
              margin-right: 20px;
              width: 88px;
              height: 120px;
              flex: 0 0 88px;
              img {
                width: 100%;
              }
            }
            .book-txt{
              h3 {
                font-size: 20px;
                line-height: 32px;
                padding-bottom: 10px;
                display: -webkit-box;
                overflow: hidden;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
              }
              p {
                font-size: 14px;
                line-height: 28px;
              }
            }
          }

          .read-percent{
            display: flex;
            align-items: center;
            padding: 20px;
            box-sizing: border-box;
            font-size: 14px;
            color: #333333;
            .read-percent-right{
              flex: 1;
            }
            
            /deep/.el-progress-bar{
              padding-right: 55px;
            }

            /deep/.el-progress-bar__inner{
              background-color: #0FC29A;
            }

            /deep/.el-progress__text{
              color: #0FC29A !important;
              margin-left: 10px;
            }
          }

          .catalog-title {
            border-top: 2px solid #E3E3E3;
            border-bottom: 1px solid #e3e3e3;
            font-size: 18px;
            line-height: 54px;
            text-align: center;
            color: #333;
            font-weight: bold;
          }
    
          .catalog-list{
            flex: 1;
            overflow: hidden;
            overflow-y: scroll;
          }
        }
    
        .setting.hideSetting {
          margin-left: -400px;
        }
    
        .setting{
          width: 400px;
          height: 100%;
          border-right: 1px solid #e3e3e3;
          margin-left: 0;
          transition: margin-left 0.3s;
          z-index: 3;
          display: flex;
          flex-direction: column;
        }
    
        .drag-action{
          position: absolute;
          width: 6px;
          height: 100%;
          right: -3px;
          top: 0;
          cursor: e-resize;
          z-index: 3;
        }
      }
      
      .read-main {
        background: #E3E3E3;
        min-width: 750px;
        width: 100%;
        overflow: hidden;
        overflow-x: auto;
        .read-main-mid {
          height: 100%;
          width: 100%;
          position: relative;
          transform: scale(1);
          transform-origin: 0% 0%;
          .bg-logo {
            width: 131px;
            height: 35px;
            position: absolute;
            right: 30px;
            bottom: 30px;
            img {
              width: 100%;
               opacity: 0.15;
            }
          }
          .read-content {
            margin: 0 auto;
            text-align: left;
            width: 750px;
            height: 100%;
            overflow: auto;
            font-size: 20px;
            line-height: 1.8;
            background: #DBECFA;
            position: relative;
            > p {
              text-indent: 40px;
            }
          }
          .read-content,
          .read-content * {
            user-select: text;
          }
          
          .position-fixed{
            width: 110rem;
            height: 68rem;
            position: absolute;
            top: 50%;
            margin-top: -34rem;
            right: 50%;
            margin-right: -375rem;
            display: flex;
            transition: left 0.2s linear;
            z-index: 10;
            background: #F48450;
            box-shadow: 0px 3px 16px 0px rgba(244,132,80,0.59);
            border-radius: 10px 0px 0px 10px;
            line-height: 68rem;
            font-size: 26rem;
            color: #fff;
            padding-left: 49rem;

            &:before{
              content: '';
              width: 28rem;
              height: 28rem;
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              left: 11rem;
              background: url("~@/assets/images/common/position-back-icon.png") center center no-repeat;
              background-size: contain;
            }
          }
        }
        
        .bubble {
          position: absolute;
          border: 1px solid #ccc;
          height: 40px;
          width: 320px;
          background: #2f4058;
          border-radius: 6px;
          display: flex;
          justify-content: space-between;
          z-index: 1000; /* 确保气泡显示在其他内容之上 */
          box-shadow: 0 3px 8px 0 rgba(32, 37, 36, 0.2);
          a {
            width: 80px;
            display: block;
            text-align: center;
            font-size: 14px;
            line-height: 40px;
            color: #d6d6d6;
            user-select: none !important;
          }
          a:hover {
            cursor: pointer;
            color: #fff;
          }
        }
      }
  
      .action-right.hideActionRight {
        margin-right: -400px;
        transform: scale(0)
      }
  
      .action-right{
        flex: 0 0 var(--sidebar-right-width);
        width: var(--sidebar-right-width);
        height: 100%;
        border-left: 1px solid #e3e3e3;
        margin-right: 0;
        transition: margin-right 0.3s;
        z-index: 3;
        display: flex;
        flex-direction: column;
        position: relative;
        overflow: hidden;
        
        .action-right-block{
          width: 100%;
          height: 100%;
          overflow: auto;
        }

        .setting-right{
          width: 400px;
          height: 100%;
          display: flex;
          flex-direction: column;
        }

        .action-right-title{
          flex: 0 0 78rem;
          font-size: 20px;
          line-height: 24px;
          color: #333;
          font-weight: bold;
          padding: 32px 22px 21px;
          border-bottom: 1px solid #E3E3E3;
        }
        
        .blank-box {
          margin: 90px auto 30px;
          padding-top: 150px;
          font-size: 16px;
          text-align: center;
          color: #a5b3c6;
          width: 280px;
          height: 150px;
          background: url("~@/assets/images/common/blank_pic.png") center center no-repeat;
          background-size: contain;
        }

        .action-right-inner{
          flex: 1;
          overflow: hidden;
          overflow-y: auto;
        }
        
        .drag-action{
          position: absolute;
          width: 6px;
          height: 100%;
          left: -3px;
          top: 0;
          cursor: e-resize;
          z-index: 3;
        }
      }
    }
  
    .side-bar-right{
      width: 70px;
      height: 100%;
      padding: 20px 0;
      background: #fff;
      position: relative;
      // box-shadow: 3px 0 8px 0 rgba(32,37,36,0.2);
      box-shadow: -3px 0px 8px 0px rgba(32,37,36,0.2);
      z-index: 5;
      
      .actions-btn{
        width: 70px;
        color: #666;
        cursor: pointer;
        user-select: none;
        font-size: 14px;
        line-height: 24px;
        text-align: center;
        flex-direction: column;
        margin-bottom: 24px;
      }

      .actions-btn-active{
        color: #0FC29A;
      }
    }
  }

}
</style>